import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "@/pages/Home";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { SmoothScroll } from "@/components/SmoothScroll";
import { API } from "@/lib/api";

// Anteprima: meta robots noindex,nofollow (default). Quando SITE_INDEXABLE=true nel backend,
// questo componente passa il meta a "index, follow".
function IndexableMeta() {
    useEffect(() => {
        fetch(`${API}/site/status`)
            .then((r) => r.json())
            .then((d) => {
                if (d && d.indexable) {
                    const m = document.querySelector('meta[name="robots"]');
                    if (m) m.setAttribute("content", "index, follow");
                }
            })
            .catch(() => {});
    }, []);
    return null;
}

function App() {
    return (
        <ErrorBoundary>
            <BrowserRouter>
                <SmoothScroll />
                <IndexableMeta />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/privacy" element={<PrivacyPage />} />
                    <Route path="/cookie" element={<CookiePolicyPage />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
